const plugins = () => {
    if ($(".list-project-preview").length) {
        $(".list-project-preview .slide-content.mobile .slide").slick({
            infinite: false,
            slidesToShow: 1.1,
            arrows: false,
        })

        $(".list-project-preview  .slide-content.mobile .btn-prev").click(function () {
            const $slide = $(this).parent().find(".slide");
            $slide.slick("slickPrev");
        })

        $(".list-project-preview  .slide-content.mobile .btn-next").click(function () {
            const $slide = $(this).parent().find(".slide");
            $slide.slick("slickNext");
        })
    }
}

module.exports = plugins